/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Open360EntitiesRetailerApiPhysicalProductVariationListItem {
    ID?: string;
    /**
     * 0 = NoBadge, 1 = New, 2 = LimitedOffer, 4 = HotDeal, 8 = SaleEndingSoon, 16 = ClearanceSale, 32 = NewCollection, 64 = Sale
     */
    Badges?: Open360EntitiesRetailerApiPhysicalProductVariationListItem.BadgesEnum;
    SKU?: string;
    Size?: string;
    Colour?: string;
    Price?: number;
    OldPrice?: number;
    InsidePrice?: number | string;
    InsideVAT?: number | string;
    IngredientsCount?: number;
    VAT?: number | string;
    ImagesID?: string[];
    NeckSize?: string;
    ChestSize?: string;
    BustSize?: string;
    WaistSize?: string;
    HipsSize?: string;
    InsideLegSize?: string;
    ShoeSize?: string;
    LegLengthSize?: string;
    DressSize?: string;
    IsHot?: boolean;
    PreparationTime?: number;
    Discount?: number;
    StockQuantity?: number;
    StockLevelThreshold?: number;
}
export namespace Open360EntitiesRetailerApiPhysicalProductVariationListItem {
    export type BadgesEnum = 0 | 1 | 2 | 4 | 8 | 16 | 32 | 64;
    export const BadgesEnum = {
        NUMBER_0: 0 as BadgesEnum,
        NUMBER_1: 1 as BadgesEnum,
        NUMBER_2: 2 as BadgesEnum,
        NUMBER_4: 4 as BadgesEnum,
        NUMBER_8: 8 as BadgesEnum,
        NUMBER_16: 16 as BadgesEnum,
        NUMBER_32: 32 as BadgesEnum,
        NUMBER_64: 64 as BadgesEnum
    };
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesRetailerApiPhysicalProductVariationListItem.ts